import { render } from "./NoPhotoVideo.vue?vue&type=template&id=58c91dfe"
import script from "./NoPhotoVideo.vue?vue&type=script&lang=js"
export * from "./NoPhotoVideo.vue?vue&type=script&lang=js"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__